// Gedeelde veld-validatie voor de vergelijk-formulieren (client + server auto-import).
// Telefoon zit in ./phone.ts (isValidDutchPhone / normalizeDutchPhone).

export const isValidEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())

export const isValidPostcode = (value: string) => /^[0-9]{4}\s?[a-zA-Z]{2}$/.test(value.trim())

// ponytail: vaste typo-lijst van de meest gebruikte NL-providers; uitbreiden als bounces andere typo's laten zien
const emailDomainTypos: Record<string, string> = {
  'gmial.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gmaill.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gmail.co': 'gmail.com', 'gmail.nl': 'gmail.com', 'gmai.com': 'gmail.com', 'gmali.com': 'gmail.com',
  'hotmial.com': 'hotmail.com', 'hotmal.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotamil.com': 'hotmail.com', 'homail.com': 'hotmail.com', 'hotmail.co': 'hotmail.com',
  'hotmial.nl': 'hotmail.nl', 'hotmal.nl': 'hotmail.nl', 'hotmai.nl': 'hotmail.nl', 'hotamil.nl': 'hotmail.nl', 'homail.nl': 'hotmail.nl',
  'outlok.com': 'outlook.com', 'outloo.com': 'outlook.com', 'outlook.co': 'outlook.com', 'outlok.nl': 'outlook.nl', 'outloo.nl': 'outlook.nl',
  'icloud.nl': 'icloud.com', 'iclod.com': 'icloud.com', 'icoud.com': 'icloud.com', 'icloud.co': 'icloud.com',
  'yaho.com': 'yahoo.com', 'yahoo.nl': 'yahoo.com', 'zigo.nl': 'ziggo.nl', 'kpnmal.nl': 'kpnmail.nl', 'kpmail.nl': 'kpnmail.nl', 'live.n': 'live.nl', 'xs4al.nl': 'xs4all.nl',
}

export const suggestEmail = (value: string): string | null => {
  const [local, domain, ...rest] = value.trim().toLowerCase().split('@')
  if (!local || !domain || rest.length) return null
  const fixed = emailDomainTypos[domain] ?? domain.replace(/\.(con|cmo|ocm|vom|comm)$/, '.com').replace(/\.(nll|ln|n)$/, '.nl')
  return fixed === domain ? null : `${local}@${fixed}`
}
